/* eslint-disable */
import React, { useState, useEffect,  useRef } from 'react';
import { useLocation } from 'react-router-dom';
import { withStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import MuiDialogTitle from '@material-ui/core/DialogTitle';
import MuiDialogContent from '@material-ui/core/DialogContent';
import MuiDialogActions from '@material-ui/core/DialogActions';
import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';
import Typography from '@material-ui/core/Typography';

import { useDispatch, useSelector } from 'react-redux'
import { createVendor, updateVendor } from '../../actions/vendorActions'
import { useSnackbar } from 'react-simple-snackbar'


const styles = (theme) => ({
  root: {
    margin: 0,
    padding: theme.spacing(2),
    backgroundColor: '#1976D2',
    marginLeft: 0,
  },
  closeButton: {
    position: 'absolute',
    right: theme.spacing(1),
    top: theme.spacing(1),
    color: 'white',
  },
});

const DialogTitle = withStyles(styles)((props) => {
  const { children, classes, onClose, ...other } = props;
  return (
    <MuiDialogTitle disableTypography className={classes.root} {...other}>
      <Typography variant="h6">{children}</Typography>
      {onClose ? (
        <IconButton aria-label="close" className={classes.closeButton} onClick={onClose}>
          <CloseIcon />
        </IconButton>
      ) : null}
    </MuiDialogTitle>
  );
});

const DialogContent = withStyles((theme) => ({
  root: {
    padding: theme.spacing(3),
  },
}))(MuiDialogContent);

const DialogActions = withStyles((theme) => ({
  root: {
    margin: 0,
    padding: theme.spacing(1),
  },
}))(MuiDialogActions);

const AddVendor = ({ setOpenVendor, openVendor, currentId, setCurrentId }) => {
  const location = useLocation()
  const formRef = useRef();
  const [vendorData, setVendorData] = useState({ name: '', email: '', phone: '', address: '',zip:'', userId: '' })
  const [user, setUser] = useState(JSON.parse(localStorage.getItem('profile')))
  const dispatch = useDispatch()
  const vendor = useSelector((state) => currentId ? state.vendors.vendors.find((c) => c.id === currentId) : null)
  // eslint-disable-next-line 
  const [openSnackbar, closeSnackbar] = useSnackbar()


  useEffect(() => {
    if (vendor && currentId!==null) {
      setVendorData(vendor)
    }else {
      setVendorData({ name: '', email: '', phone: '', address: '', userId: '' })
    }
  }, [vendor])

  useEffect(() => {
    setUser(JSON.parse(localStorage.getItem('profile')))
    setVendorData({...vendorData, userId: user?.result?.id})
  }, [location])


  useEffect(() => {
    var checkId = user?.result?.id
    if (checkId !== undefined) {
      setVendorData({ ...vendorData, userId: [checkId] })
    } 

  }, [location])


  const handleSubmitVendor = (e) => {
    e.preventDefault()
    let errorMessage = "";
    if (vendorData.name ==="") errorMessage+="Name is required."
    if (vendorData.address ==="") errorMessage+="Address is required."
    if (vendorData.city ==="") errorMessage+="City is required."
    if (vendorData.state ==="") errorMessage+="State is required."
    if (vendorData.zip ==="") errorMessage+="Zip code is required."
    if (vendorData.phone ==="") errorMessage+="Phone is required."
    if (errorMessage.length>0){
          openSnackbar(errorMessage);
      return;
    }

    const formData = new FormData(formRef.current);
        for (const key in vendorData) {
          formData.append(key, vendorData[key]);
        }
        
        formData.append("userId", user?.result?.id);
         const aML_ProgramFile = document.getElementById('aML_Program');
         if (aML_ProgramFile.files.length>0)
            formData.append("aML_Program", aML_ProgramFile.files[0]);

         
         
    if (currentId) {
      dispatch(updateVendor(currentId, formData, openSnackbar))
    } else {
      dispatch(createVendor(formData, openSnackbar))
    }
   
    clear()
    handleClose()
  }

  const clear = () => {
     //setCurrentId(null)
     setVendorData({ name: '', email: '', phone: '', address: '', userId: [] })
  }

  const handleClose = () => {
    setOpenVendor(false);
  };

  const inputStyle = {
    display: "block",
    padding: "1.4rem 0.75rem",
    width: "100%",
    fontSize: "0.8rem",
    lineHeight: 1.25,
    color: "#55595c",
    backgroundColor: "#fff",
    backgroundImage: "none",
    backgroundClip: "padding-box",
    borderTop: "0",
    borderRight: "0",
    borderBottom: "1px solid #eee",
    borderLeft: "0",
    borderRadius: "3px",
    transition: "all 0.25s cubic-bezier(0.4, 0, 1, 1)"
  }


  return (
    <div>
      <form >
        <Dialog
          onClose={(e, reason) => {
            if (reason !== 'backdropClick') {
              handleClose()
            }
          }}
          aria-labelledby="customized-dialog-title"
          open={openVendor} fullWidth
        >
          <DialogTitle id="customized-dialog-title" onClose={handleClose} style={{ paddingLeft: '20px', color: 'white' }}>
            {currentId ? 'Edit Vendor' : 'Add New Vendor'}
          </DialogTitle>
          <DialogContent dividers>


          <div className="customInputs">
              <input 
                placeholder="Name" 
                style={inputStyle} 
                name='name' 
                type='text'  
                onChange={(e) => setVendorData({...vendorData, name: e.target.value})}
                value={vendorData.name} 
              />

              <input 
                placeholder="Email" 
                style={inputStyle} 
                name='email' 
                type='text' 
                onChange={(e) => setVendorData({...vendorData, email: e.target.value})}
                value={vendorData.email} 
              />
              <input 
                placeholder="Phone" 
                style={inputStyle} 
                name='phone' 
                type='text'  
                onChange={(e) => setVendorData({...vendorData, phone: e.target.value})}
                value={vendorData.phone} 
              />
              <input 
                placeholder="Address" 
                style={inputStyle} 
                name='address' 
                type='text' 
                onChange={(e) => setVendorData({...vendorData, address: e.target.value})}
                value={vendorData.address} 
              />

              <input
                placeholder="City"
                style={inputStyle}
                name='city'
                type='text'
                onChange={(e) => setVendorData({ ...vendorData, city: e.target.value })}
                value={vendorData.city}
              />

              <input
                placeholder="State"
                style={inputStyle}
                name='state'
                type='text'
                onChange={(e) => setVendorData({ ...vendorData, state: e.target.value })}
                value={vendorData.state}
              />

              <input
                placeholder="Zip"
                style={inputStyle}
                name='zip'
                type='text'
                onChange={(e) => setVendorData({ ...vendorData, zip: e.target.value })}
                value={vendorData.zip}
              />

               <input
                placeholder="Fax"
                style={inputStyle}
                name='fax'
                type='text'
                onChange={(e) => setVendorData({ ...vendorData, fax: e.target.value })}
                value={vendorData.fax}
              />

              <input
                placeholder="Web Site"
                style={inputStyle}
                name='website'
                type='text'
                onChange={(e) => setVendorData({ ...vendorData, website: e.target.value })}
                value={vendorData.website}
              />
              <input
                placeholder="DBA"
                style={inputStyle}
                name='dba'
                type='text'
                onChange={(e) => setVendorData({ ...vendorData, dba: e.target.value })}
                value={vendorData.dba}
              />
               <input
                 placeholder="Tax ID/ EIN"
                 style={inputStyle}
                 name='taxId'
                 type='text'
                 onChange={(e) => setVendorData({ ...vendorData, taxId: e.target.value })}
                 value={vendorData.taxId}
               />
              <label for="aML_Program" style={inputStyle}>Upload AML Program</label>
               <input
                placeholder="AML Program"
                style={inputStyle}
                name='aML_Program'
                id='aML_Program'
                type='file'

              />
              <a href={global.config.API_URL + vendorData.aML_Program_Link} target='_blank'>{vendorData.aML_Program_FileNameWithExtension}</a>
          </div>

          </DialogContent>
          <DialogActions>
            <Button onClick={handleSubmitVendor} variant="contained" style={{ marginRight: '25px' }} >
              Save Vendor
            </Button>
          </DialogActions>
        </Dialog>
      </form>
    </div>
  );
}

export default AddVendor